if(!customElements.get('custom-multimedia-collage')){
    class CustomMultimediaCollage extends HTMLElement {
        constructor(){
            super();
    
            this.init();
        }
    
    
        init(){
            this.videos = this.querySelectorAll('video');
            this.videos.forEach((video) => {
                video.addEventListener('loadeddata', function(e){
                    video.classList.add('loaded');
                });

                if (video.readyState >= 2) {
                    video.classList.add('loaded');
                }
            })
        }
    }
    
    customElements.define('custom-multimedia-collage', CustomMultimediaCollage);
}